import { render } from "./injuryList.vue?vue&type=template&id=5f901106&scoped=true"
import script from "./injuryList.vue?vue&type=script&lang=js"
export * from "./injuryList.vue?vue&type=script&lang=js"

import "./injuryList.vue?vue&type=style&index=0&id=5f901106&scoped=true&lang=scss"

import exportComponent from "/root/workspace/interactive-system-pc_dBxe/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f901106"]])

export default __exports__